<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="450">
      <v-card class="pa-6 modal-card">
        <v-card-title class="pa-0 pb-7">
          <v-row no-gutters>
            <v-col cols="11">
              <h3 class="modal-card__title">{{ cardTitle }}</h3>
            </v-col>
            <v-col cols="1">
              <v-btn icon @click="closeHandler">
                <v-icon large color="black">close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-form ref="form" lazy-validation @submit.prevent="onSubmitHandler">
          <v-card-text class="px-0">
            <v-col class="pa-0 pb-6">
              <span class="modal-card__info">{{ item.organizationInn }}</span>
              <span class="modal-card__info pb-4">{{ item.organizationName }}</span>
              <span class="modal-card__info">{{ item.personalInn }}</span>
              <span class="modal-card__info pb-4">{{ item.fullName }}</span>
              <span class="modal-card__date">
                Сертификат активен до {{ moment.unix(item.validUntil).format('LL') }}
              </span>
            </v-col>
            <v-row no-gutters justify="start" v-if="formType === types.WATCH">
              <v-col cols="12">
                <v-row justify="start" align="center" no-gutters>
                  <v-col cols="1" class="mr-3">
                    <v-radio-group v-model="radios" :mandatory="false" class="mt-8">
                      <v-radio value="radio1" color="#007bff" />
                    </v-radio-group>
                  </v-col>
                  <v-col cols="8">
                    <span
                      :class="
                        radio2 ? 'modal-card__label modal-card__label-grey' : 'modal-card__label modal-card__label-blue'
                      "
                    >
                      Телефон для ПИН-кода
                    </span>
                    <v-text-field
                      placeholder="777010203"
                      :rules="radio1 ? telNumberRules : []"
                      :disabled="radio2"
                      outlined
                      v-model="telNumber"
                      v-mask="telMask"
                      autocomplete="off"
                      clearable
                      validate-on-blur
                    />
                  </v-col>
                </v-row>
                <v-row v-if="userRole === 'super_admin'" no-gutters justify="start" align="center">
                  <v-col cols="1" class="mr-3">
                    <v-radio-group v-model="radios" :mandatory="false" class="mt-8">
                      <v-radio value="radio2" color="#007bff" />
                    </v-radio-group>
                  </v-col>
                  <v-col cols="8">
                    <span
                      :class="
                        radio1 ? 'modal-card__label modal-card__label-grey' : 'modal-card__label modal-card__label-blue'
                      "
                    >
                      ПИН-код
                    </span>
                    <v-text-field
                      placeholder="1234"
                      :rules="radio2 ? pinRules : []"
                      :disabled="radio1"
                      outlined
                      v-model="pinCode"
                      v-mask="pinMask"
                      autocomplete="off"
                      clearable
                      validate-on-blur
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pa-0">
            <v-spacer />
            <v-btn
              dark
              large
              class="text-capitalize"
              width="205"
              rounded
              :outlined="isOutlined"
              :color="btnColor"
              :loading="loading"
              type="submit"
            >
              <v-icon left v-if="isIcon">{{ btnIcon }}</v-icon>
              {{ btnTitle }}
            </v-btn>
            <v-spacer />
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mask } from 'vue-the-mask'
export default {
  name: 'Modal',
  directives: { mask },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true
    },
    item: {
      type: Object,
      default: () => {},
      required: true
    },
    formType: {
      type: String,
      default: ''
    },
    userRole: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    types: { PAUSE: 'pause', STOP: 'stop', WATCH: 'watch', INCREASE: 'increase' },
    telNumberRules: [v => (v && v.length > 11) || 'Номер телефона должен быть равен 12 цифрам'],
    pinRules: [v => (v && v.length > 3) || 'Пин код должен быть равен 4 цифрам'],
    telMask: '996#########',
    pinMask: '####',
    telNumber: '',
    pinCode: '',
    cardTitle: 'Форма',
    btnTitle: 'Нажать',
    btnColor: '#007AFF',
    btnIcon: 'check',
    isIcon: false,
    isOutlined: true,
    loading: false,
    radio1: true,
    radio2: false,
    radios: 'radio1'
  }),
  watch: {
    formType(val) {
      switch (val) {
        case this.types.WATCH:
          this.setProperties('Информация', 'Сохранить', '#007AFF', '', false, false)
          this.telNumber = this.item.phone
          break
        case this.types.INCREASE:
          this.setProperties('Повысить', 'Повысить', '#6DCA83', 'attach_money', true, false)
          break
        case this.types.PAUSE:
          this.setProperties('Приостановить', 'Приостановить', '#F0956F', 'pause_circle_outline', true, false)
          break
        case this.types.STOP:
          this.setProperties('Отозвать', 'Отозвать', '#EB5757', 'close', true, true)
          break
      }
    },
    radios(val) {
      if (val === 'radio1') {
        this.radio1 = true
        this.radio2 = false
        this.pinCode = ''
      } else {
        this.radio1 = false
        this.radio2 = true
        this.telNumber = ''
      }
    }
  },
  methods: {
    setProperties(cardTitle, btnTitle, btnColor, btnIcon, isIcon, isOutlined) {
      this.cardTitle = cardTitle
      this.btnTitle = btnTitle
      this.btnColor = btnColor
      this.btnIcon = btnIcon
      this.isIcon = isIcon
      this.isOutlined = isOutlined
    },
    closeHandler() {
      this.$emit('clear-modal-data')
      this.$emit('close-modal', false)
      this.telNumber = ''
      this.pinCode = ''
      this.$refs.form.resetValidation()
    },
    async setDispatch(dispatchTitle, payload) {
      if (this.$refs.form.validate()) {
        this.loading = true
        await this.$store.dispatch(dispatchTitle, payload)
        this.loading = false
        this.closeHandler()
      }
    },
    onSubmitHandler() {
      switch (this.formType) {
        case this.types.WATCH:
          const data = this.radios === 'radio1' ? { phone: this.telNumber } : { pinCode: this.pinCode }
          this.setDispatch('EDIT_PHONE_OR_PIN', {
            userId: this.item.id,
            data
          })
          break
        case this.types.INCREASE:
          break
        case this.types.PAUSE:
          this.setDispatch('SET_PAUSE_TO_PAYMENT', {
            inn: this.item.personalInn,
            organizationInn: this.item.organizationInn
          })
          break
        case this.types.STOP:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-card {
  &__title {
    font-weight: 600;
    font-size: 32px;
    color: #000;
    padding-right: 90px;
  }
  &__info {
    font-weight: 400;
    font-size: 16px;
    color: #000;
    display: block;
  }
  &__date {
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    color: rgba(51, 51, 51, 0.54);
  }
  &__label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
  }
  &__label-blue {
    color: #007aff;
  }
  &__label-grey {
    color: grey;
  }
}
</style>
